import axios from "axios";
import { City, Lead, Review, Service } from "@/types";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const contentApi = {
  services: () => api.get<Service[]>("/content/services").then(r => r.data),
  cities: () => api.get<City[]>("/content/cities").then(r => r.data),
  reviews: () => api.get<Review[]>("/content/reviews").then(r => r.data),
};
export const submitQuote = (payload: unknown) => api.post("/quotes", payload).then(r => r.data);
export const adminApi = {
  login: (email: string, password: string) => api.post("/admin/login", { email, password }).then(r => r.data),
  leads: (token: string, status?: string) => api.get<Lead[]>("/admin/leads", { headers: { Authorization: `Bearer ${token}` }, params: status ? { status } : {} }).then(r => r.data),
  update: (token: string, id: string, status: string) => api.patch<Lead>(`/admin/leads/${id}`, { status }, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.data),
};